import { createApp } from 'vue'
import axios from 'axios'

import Cookies from 'js-cookie'

import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import locale from 'element-plus/es/locale/lang/zh-cn'

import '@/assets/styles/index.scss' // global css
import '@/assets/icons/el-icon/iconfont.css' // 自定义icon

import App from './App'
import store from './store'
import router from './router'
import directive from './directive' // directive

// 注册指令
import plugins from './plugins' // plugins
import { download } from '@/utils/request'

// svg图标
import 'virtual:svg-icons-register'
import SvgIcon from '@/components/SvgIcon'
import elementIcons from '@/components/SvgIcon/svgicon'

import './permission' // permission control

import { useDict } from '@/utils/dict'
import { parseTime, resetForm, addDateRange, handleTree, selectDictLabel, selectDictLabels } from '@/utils/ruoyi'
// 通用组件
import component from '@/components/common'
// 文件上传组件
// import FileUpload from "@/components/FileUpload"
// 图片上传组件
import ImageUpload from "@/components/ImageUpload"
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
// Vue3表单组件
import VForm3 from '@/components/vform/designer.umd.js'
import '@/components/vform/designer.style.css'
// 打印
import Print from 'vue3-print-nb'

// 全局引入自定义流程表单组件
import flowForms from '@/components/FlowForm/index'

window.axios=axios

const app = createApp(App)
app.config.warnHandler = () => null
// 全局方法挂载
app.config.globalProperties.useDict = useDict
app.config.globalProperties.download = download
app.config.globalProperties.parseTime = parseTime
app.config.globalProperties.resetForm = resetForm
app.config.globalProperties.handleTree = handleTree
app.config.globalProperties.addDateRange = addDateRange
app.config.globalProperties.selectDictLabel = selectDictLabel
app.config.globalProperties.selectDictLabels = selectDictLabels

// 全局组件挂载
// app.component('FileUpload', FileUpload)
app.component('ImageUpload', ImageUpload)
app.component('ImagePreview', ImagePreview)

app.use(flowForms)
app.use(router)
app.use(store)
app.use(plugins)
app.use(elementIcons)
// 全局注册VForm3，同时注册了v-form-designer、v-form-render等组件
app.use(VForm3)
app.use(Print)
app.component('svg-icon', SvgIcon)

directive(app)

// 使用element-plus 并且设置全局的大小
app.use(ElementPlus, {
  locale: locale,
  // 支持 large、default、small
  size: Cookies.get('size') || 'default'
})
// 修改 el-dialog 默认点击遮照为不关闭
app._context.components.ElDialog.props.closeOnClickModal.default = false
// 修改 el-drawer 默认点击遮照为不关闭
app._context.components.ElDrawer.props.closeOnClickModal.default = false

app.use(component)
app.mount('#app')
